import { render, staticRenderFns } from "./AuthResetPassword.vue?vue&type=template&id=610e87c6&scoped=true"
import script from "./AuthResetPassword.vue?vue&type=script&lang=js"
export * from "./AuthResetPassword.vue?vue&type=script&lang=js"
import style0 from "./AuthResetPassword.vue?vue&type=style&index=0&id=610e87c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e87c6",
  null
  
)

export default component.exports